
(function ($) {

    var flag = 0;
    $('.sticky-nav .mobile-tab').hide();
    function setDiv() {
        var contentLeft = $('.header-menu .container').offset().left,
            contentWidth = $('.header-menu .container').outerWidth();
        $('.sticky-nav').next().each(function () {
            if ($(this).parent().hasClass('left')) {
                $(this).css('padding-left', contentLeft + 47 + 'px');
            }
            else {
                // $(this).css('padding-right', $(window).width() - (contentLeft + contentWidth - 30) + 'px');
            }
        });
    }

    function assignHeight() {
        $('.tab-with-grid .tab-content .col-two .content').each(function () {
            var Height = $(this).outerHeight();
            $(this).parents('.item').children().css('height', Height + 'px');
        });
    }

    function scrollOnClick(){
        var scroll = $(window).scrollTop();
        if(!$(this).hasClass('active')){
            var $Id = $(this).children('a').attr('href');
            var offsetTop = $($Id).offset().top;
            $('.sticky-nav ul li').removeClass('active');
            $(this).addClass('active');

            if(scroll > offsetTop){
                var navHeight = $('.sticky-nav > div').height()+ $('.header-menu').height();
            }
            else{
                var navHeight = $('.sticky-nav > div').height();
            }
            $('html, body').animate({
                scrollTop: $($Id).offset().top - navHeight - 20
            }, 500);
        }
    }

    // On DOM ready
    $(function () {
        setDiv();
        assignHeight();
        $('.sticky-nav ul li').on('click', function (e) {
            e.preventDefault();
            flag = 1;
            scrollOnClick.call(this);
            setTimeout(function () {
                flag = 0;
            }, 550);
        });
    });

    if($(".sticky-nav").length > 0) {
        var offsetTop = $('.sticky-nav').next().offset().top,
            navHeight = $('.header-menu').height(),
            tabsHeight = $('.sticky-nav').height();
    }

    var activeSelector = jQuery('section'),
        nav = jQuery('.sticky-nav'),
        nav_height = nav.outerHeight();

    $(window).on('resize', function () {
        setDiv();
        setTimeout(function () {
            if($(".sticky-nav").length > 0) {
                offsetTop = $('.sticky-nav').offset().top + parseInt($('.sticky-nav').css('padding-top')) ,
                    navHeight = $('.header-menu').height(),
                    tabsHeight = $('.sticky-nav').height();
            }
        },100);
        activeSelector = jQuery('section'),
            nav = jQuery('.sticky-nav'),
            nav_height = nav.outerHeight();
    });

    $(document).ready(function () {
        if ($(".sticky-nav").length > 0) {
            offsetTop = $('.sticky-nav').offset().top + parseInt($('.sticky-nav').css('padding-top')),
                navHeight = $('.header-menu').height(),
                tabsHeight = $('.sticky-nav > div ').outerHeight();
        }
    });
    $(window).on("load",function () {
        $('.sticky-nav').css({'opacity': '1'});
    });
    $(window).on('scroll', function () {
        $('.sticky-nav').css({'opacity': '1'});
        if (window.matchMedia('(min-width: 992px)').matches) {
            $('.sticky-nav').css({'display': 'block'});
            var scrolled = jQuery(document).scrollTop();
            if ((scrolled > offsetTop)) {
                $(".sticky-nav > div").css({
                    'position': 'fixed',
                    'z-index': '9',
                    'background': '#fff',
                    'padding': '30px 0',
                    'box-shadow': ' 0px 0px 6px -3px #000',
                    'left': '0'
                });
                if($(".header-inner").hasClass('off-canvas')){
                    $(".sticky-nav > div").css({'top': '95px'}).addClass('scroll-down');
                }
                else{
                    $(".sticky-nav > div").css({'top': '0'}).removeClass('scroll-down');
                }
                $(".sticky-nav").next().css('margin-top', tabsHeight + 'px');
            } else if ((scrolled < offsetTop - navHeight)) {
                $(".sticky-nav").next().css('margin-top', '');
                $(".sticky-nav > div").removeAttr('style').removeClass('scroll-down');;
            }

            if (flag == 0) {
                activeSelector.each(function () {
                    var top = $(this).offset().top - (nav_height),
                        bottom = top + $(this).outerHeight();
                    if (scrolled >= top && scrolled <= bottom) {
                        nav.find('a[href="#' + $(this).attr('id') + '"]').parent('li').addClass('active').siblings().removeClass('active');

                    }
                });
            }
        }
        else{
            $('.sticky-nav').css({'display': 'none'});
            $(".sticky-nav").next().css('margin-top', '0');


        }
        scroll = $(document).scrollTop();
        // if (window_width <= 991){
        //     $('.sticky-nav').css({'display': 'none'});
        //
        // }
        // else {
        //     $('.sticky-nav').css({'display': 'block'});
        // }

    });

})(jQuery);